export default __webpack_public_path__ + "static/reglement interieur Anglais-f8163a2e886612886b4a2984f9656ce1.pdf";